export default function getStripeKey() {
  return process.env.REACT_APP_STRIPE_KEY ?? "";
}
